import StorageHelper from '../../../helper.js';
const scope = 'ADS/breadcrumb';

const defaultState = {
  activeView: null,
  adSelectionName: 'Select Facebook Ad',
  adSetSelectionName: 'Select Facebook AdSet',
  campaignSelectionName: 'Select Facebook Campaign',
  component: '',
  fieldMappingSelectionName: 'Field Mapping',
  step: 0,
};

const mod = {
    namespaced: true,
    state: {
        activeView: null,
        adSelectionName: 'Select Facebook Ad',
        adSetSelectionName: 'Select Facebook AdSet',
        campaignSelectionName: 'Select Facebook Campaign',
        component: '',
        fieldMappingSelectionName: 'Field Mapping',
        step: 0,
    },
    mutations: {
        activeView: (state, activeView) => {
            state.activeView = activeView;
        },
        adSelectionName: (state, name) => {
            state.adSelectionName = name;
        },
        adSetSelectionName: (state, name) => {
            state.adSetSelectionName = name;
        },
        campaignSelectionName: (state, name) => {
            state.campaignSelectionName = name;
        },
        component: (state, component) => {
            state.component = component;
        },
        fieldMappingSelectionName: (state, name) => {
            state.fieldMappingSelectionName = name;
        },
        step: (state, step) => {
            state.step = step;
        },
    },
    actions: {
        activeView({ commit }, activeView) {
          StorageHelper.setLocalStorageVar(commit, activeView, 'activeView', scope);
        },
        adSelectionName({ commit }, name) {
          name = name ? name : defaultState.adSelectionName;
          StorageHelper.setLocalStorageVar(commit, name, 'adSelectionName', scope);
        },
        adSetSelectionName({ commit }, name) {
          name = name ? name : defaultState.adSetSelectionName;
          StorageHelper.setLocalStorageVar(commit, name, 'adSetSelectionName', scope);
        },
        campaignSelectionName({ commit }, name) {
          name = name ? name : defaultState.campaignSelectionName;
          StorageHelper.setLocalStorageVar(commit, name, 'campaignSelectionName', scope);
        },
        component({ commit }, component) {
          StorageHelper.setLocalStorageVar(commit, component, 'component', scope);
        },
        fieldMappingSelectionName({ commit }, name) {
          name = name ? name : defaultState.fieldMappingSelectionName;
          StorageHelper.setLocalStorageVar(commit, name, 'fieldMappingSelectionName', scope);
        },
        step({ commit }, step) {
          StorageHelper.setLocalStorageVar(commit, step, 'step', scope);
        },
        reset({ commit }) {
          StorageHelper.resetState(commit, defaultState, scope);
        },
    },
    getters: {
        activeView (state) {
            return state.activeView;
        },
        adSelectionName (state) {
            return state.adSelectionName;
        },
        adSetSelectionName (state) {
            return state.adSetSelectionName;
        },
        campaignSelectionName (state) {
            return state.campaignSelectionName;
        },
        component (state) {
            return state.component;
        },
        fieldMappingSelectionName (state) {
            return state.fieldMappingSelectionName;
        },
        step (state) {
            return state.step;
        },
    }
};

export default mod;
